export class ConditionalFunctions {}
